import React from 'react';
import { labelStyles, LabelProps } from './styles';

const Label18: React.FC<LabelProps> = ({
    children,
    className,
    style,
    isBold,
    isPrimary,
}) => {
    const { label18Styles, primary, bold } = labelStyles();
    const classes = `${className} ${label18Styles} ${
        isPrimary ? primary : ''
    } ${isBold ? bold : ''}`;
    return (
        <div className={classes} style={style}>
            {children}
        </div>
    );
};

export default Label18;
